import 'react-app-polyfill/ie11' // needed for ie11 support
import 'react-app-polyfill/stable' // needed for ie11 support
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import smoothscroll from 'smoothscroll-polyfill'
import { PublicClientApplication } from '@azure/msal-browser'
import { azureAuthConfig } from './azureAuthConfig'

if (module.hot) {
  module.hot.accept()
}

smoothscroll.polyfill()

ReactDOM.render(
  <React.StrictMode>
    <App azurePublicClientApp={new PublicClientApplication(azureAuthConfig)} />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
